angular.module('homebot.directives')

.directive('scrollTo', ['ScrollService', function(ScrollService){
  return {
    restrict: 'A',
    controllerAs: 'scrollToCtrl',
    bindToController: {
      scrollTo: '@',
    },
    scope: {},
    controller: function(){ },
    link: function(scope, el, attrs, ctrl){
      el.on('click', function(e){
        ScrollService.scroll({target: attrs.scrollTo});
        e.preventDefault();
      });
    }
  }
}]);
